<template>
  <div class="col" gutter="20">
    <Title title="教學資源點擊追蹤" />
    <div class="back">
      <el-button @click="goBack" class="return-btn">
        <img src="@/assets/return-icon.png" />
      </el-button>
    </div>

    <div class="resource-info">
      <div class="info-item">
        <div class="info-label">名稱</div>
      </div>
      <div class="info-item">
        <div class="info-label">{{ resourceTitle }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">總點擊次數</div>
        <div class="info-value">{{ totalClickCount }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">實際點擊人數</div>
        <div class="info-value">{{ uniqueUserCount }}</div>
      </div>
    </div>

    <el-table :data="resourceData" v-loading="loading">
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="單位" prop="jobs">
        <template slot-scope="{ row }">
          {{ mapJob(row.jobs).department || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="jobs" label="職位">
        <template slot-scope="{ row }">
          {{
            mapJob(row.jobs).position.includes("其他")
              ? `${mapJob(row.jobs).position.split("，")[1]}`
              : mapJob(row.jobs).position
          }}
        </template>
      </el-table-column>

      <el-table-column prop="jobs" label="任教領域">
        <template slot-scope="{ row }">
          {{
            mapJob(row.jobs).subject &&
            mapJob(row.jobs).subject.includes("其他")
              ? `${mapJob(row.jobs).subject.split("，")[1]}`
              : teacherSubjectOptions.includes(mapJob(row.jobs).subject)
              ? mapJob(row.jobs).subject
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="session_list" label="歷屆報名挑戰" align="center">
        <template slot-scope="{ row }">
          <pre v-if="row.session_list">{{
            row.session_list && row.session_list.join("\n")
          }}</pre>
        </template>
      </el-table-column>
      <el-table-column
        label="點擊次數"
        prop="count"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <el-button
            @click="showUserRecords(row)"
            type="text"
            class="view-records"
            >查看用戶紀錄</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 用戶紀錄彈窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :show-close="true"
      custom-class="user-records-dialog"
    >
      <div slot="title" class="dialog-title">用戶紀錄</div>

      <div class="user-info">
        <div class="info-row">
          <div class="info-item">
            <div class="info-label" style="width: 40px">姓名</div>
            <div class="info-value">{{ currentUser.name }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">歷屆報名挑戰</div>
            <div class="info-value">{{ currentUser.batchNumber }}</div>
          </div>
          <div class="info-item" />
        </div>

        <div class="info-row">
          <div class="info-item">
            <div class="info-label" style="width: 40px">單位</div>
            <div class="info-value">{{ currentUser.department }}</div>
          </div>
          <div class="info-item">
            <div class="info-label" style="width: 40px">職位</div>
            <div class="info-value">{{ currentUser.position }}</div>
          </div>
          <div class="info-item">
            <div class="info-label" style="width: 70px">任教領域</div>
            <div class="info-value">{{ currentUser.teachingField }}</div>
          </div>
        </div>
      </div>

      <div class="records-title">點擊紀錄</div>

      <div class="records-table-container">
        <div class="records-header">
          <div class="header-item resource-name">名稱</div>
          <div class="header-item click-count">點擊次數</div>
        </div>

        <div class="records-body">
          <div class="records-scroll-container">
            <div
              v-for="(record, index) in currentUserRecords"
              :key="index"
              class="record-row"
            >
              <div class="record-item resource-name">
                {{ record.title }}
              </div>
              <div class="record-item click-count">{{ record.count }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import moment from "moment-timezone";
import Title from "@/components/backendManage/Title";

export default {
  components: { Title },
  computed: {
    ...mapState("EduResource", ["dataList"]),
  },
  data() {
    return {
      loading: true,
      resourceTitle: "",
      totalClickCount: 0,
      uniqueUserCount: 0,
      resourceData: [],
      dialogVisible: false,
      currentUser: {},
      currentUserRecords: [],
      teacherSubjectOptions: [
        "語文領域（國語文、英語文、本土語言）",
        "數學領域",
        "自然科學領域（物理、化學、生物、地球科學）",
        "社會領域（歷史、地理、公民與社會）",
        "藝術領域（視覺藝術、音樂、表演藝術）",
        "綜合活動領域（生活課程、童軍教育、家政、社團活動、生涯規劃）",
        "科技領域（資訊科技、生活科技、科技與工程）",
        "健康與體育領域",
        "其他（彈性課程、校訂課程、其他等）",
      ],
    };
  },
  methods: {
    ...mapActions("EduResource", [
      "getEduResourceDetailLink",
      "getEduResourceDetailUser",
    ]),
    mapJob(jobs = []) {
      const jobList = jobs.filter((j) => j.presently_employed);
      if (jobList.length > 0) {
        return jobList.reduce((a, b) => (b.start_time > a.start_time ? b : a));
      } else {
        if (jobs.length > 0) {
          return jobs.reduce((a, b) => (b.end_time > a.end_time ? b : a));
        }
        return new Object();
      }
    },
    goBack() {
      this.$router.push("/backend-manage/free-resource-manage");
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    async showUserRecords(row) {
      try {
        this.currentUser.name = row.name;
        this.currentUser.batchNumber =
          row.session_list && row.session_list.join("\n");
        this.currentUser.department = this.mapJob(row.jobs).department || "";
        this.currentUser.position = this.mapJob(row.jobs).position.includes(
          "其他"
        )
          ? this.mapJob(row.jobs).position.split("，")[1]
          : this.mapJob(row.jobs).position;
        this.currentUser.teachingField =
          this.mapJob(row.jobs).subject &&
          this.mapJob(row.jobs).subject.includes("其他")
            ? `${this.mapJob(row.jobs).subject.split("，")[1]}`
            : this.teacherSubjectOptions.includes(this.mapJob(row.jobs).subject)
            ? this.mapJob(row.jobs).subject
            : "";
        this.currentUserRecords = await this.getEduResourceDetailUser({
          account: row.account,
        });
        this.dialogVisible = true;
      } catch (error) {
        console.error("獲取資源追蹤數據失敗:", error);
        this.$message.error("獲取資源追蹤數據失敗");
        this.loading = false;
      }
    },
    getUserInitial(name) {
      return name ? name.charAt(0) : "Y";
    },
    async FreeResourceManageDetail(link) {
      this.loading = true;
      try {
        this.resourceData = await this.getEduResourceDetailLink({ link: link });
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } catch (error) {
        console.error("獲取資源追蹤數據失敗:", error);
        this.$message.error("獲取資源追蹤數據失敗");
        this.loading = false;
      }
    },
  },
  async created() {
    const routeId = this.$route.params.id;
    try {
      const foundResource = this.dataList.list.find(
        (item) => item.id === routeId
      );
      this.resourceTitle = foundResource.title;
      this.totalClickCount = foundResource.count;
      this.uniqueUserCount = foundResource.usersCount;
      await this.FreeResourceManageDetail(foundResource.link);
    } catch (error) {
      console.error("獲取資源追蹤數據失敗:", error);
      this.$message.error("獲取資源追蹤數據失敗");
      this.$router.push("/backend-manage/free-resource-manage");
    }
  },
};
</script>

<style lang="scss" scoped>
.return-btn {
  width: 60px;
  background-color: #b8bcc5;
  padding: 8px 15px 5px;
  border-radius: 7px;
  img {
    width: 100%;
  }
}
:deep(.el-dialog__body) {
  padding: 0 20px 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.back {
  margin-bottom: 20px;
}

.resource-info {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid #000;
  padding-bottom: 15px;

  .info-item {
    margin-right: 40px;
    display: flex;
    align-items: center;

    .info-label {
      font-weight: bold;
      color: #000;
      font-weight: 700;
    }

    .info-value {
      color: #000;
      font-weight: 700;
      margin-left: 20px;
    }
  }
}

.view-records {
  color: #409eff;
}

.el-table {
  margin-top: 20px;
}

/* 彈窗樣式 */
.dialog-title {
  font-size: 18px;
  font-weight: bold;
}

.user-info {
  .info-row {
    display: flex;
    margin-bottom: 25px;

    .info-item {
      flex: 1;
      display: flex;

      .info-label {
        width: 95px;
        font-weight: bold;
        color: #878a90;
        font-weight: 700;
      }

      .info-value {
        flex: 1;
        color: #000;
        font-weight: 700;
      }
    }
  }
}

.records-title {
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 10px;
  color: #878a90;
}
:deep(.el-icon-close):before {
  font-size: 30px;
}

.records-table-container {
  background-color: #efefef;
  border-radius: 14px;
  overflow: hidden;
  padding: 20px;

  .records-header {
    display: flex;
    padding: 0 0 10px;
    margin-right: 18px;
    border-bottom: 1px solid #c8c8c8;

    .header-item {
      &.user-avatar {
        width: 60px;
      }

      &.resource-name {
        flex: 1;
      }

      &.click-count {
        width: 100px;
        text-align: center;
      }
    }
  }

  .records-body {
    max-height: 210px;
    overflow-y: scroll;
    padding-right: 10px;

    /* 客製化卷軸 */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ee6a8d;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      border-radius: 4px;
    }

    .records-scroll-container {
      max-height: 250px;
    }

    .record-row {
      display: flex;
      padding: 10px 0;
      border-top: 1px solid #ebeef5;
      border-bottom: 1px solid #c8c8c8;
      &:nth-last-child(1) {
        border-bottom: none;
      }

      .record-item {
        &.user-avatar {
          width: 60px;
        }

        &.resource-name {
          flex: 1;
        }

        &.click-count {
          width: 100px;
          text-align: center;
        }
      }
    }
  }
}

.avatar-circle {
  width: 30px;
  height: 30px;
  background-color: #8e44ad;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}
:deep(.el-table)::before {
  display: none;
}
</style>
